export default {"src":"/_next/static/media/cision.cf33c102.svg","height":33,"width":157,"blurWidth":0,"blurHeight":0};